export default {
  backendUrl: 'https://api.bluecargo.io',
  launchDarklyClientId: '61817bf701d27d6405892a8a',
  GA_ID: 'UA-139406922-1',
  HOTJAR_ID: 1320891,
  AMPLITUDE_ID: '9689313c9a7de1cf29d52da008552860',
  stripe_api_key: 'pk_live_JlUAxMiFomxPPmjUGtUos4Y400cNsZskSx',
  ENV_LABEL: 'production',
};
